import { getOGImageURL, getOGSiteName, isStandalone } from '@digital-retail/store-manager';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { WithUrl } from '../WithUrl';

export const getBreadcrumbData = (breadcrumb, region, store) => {
  const regionName = isStandalone({ store }) ? `${region}_${store}` : region;
  const host = WithUrl('FULL_HOST', regionName);
  return breadcrumb.map((e, i) => {
    return {
      position: i,
      name: e.label,
      item: `${host}${e.link}`,
    };
  });
};

export const PLPSeo = ({ SiteProps }) => {
  const { regionCode, metadata, canonicalUrl, breadcrumb, store } = SiteProps;

  const canonicalUrlAux = metadata?.canonical || canonicalUrl;

  const title = metadata?.title || '';
  const description = metadata?.description || '';

  const breadcrumbData = getBreadcrumbData(breadcrumb || [], regionCode, store);
  const siteName = getOGSiteName({ regionCode, store });

  return (
    <>
      <Head>
        <title> {title} </title>
      </Head>
      <NextSeo
        canonical={canonicalUrlAux}
        description={description}
        openGraph={{
          description,
          canonicalUrlAux,
          site_name: siteName,
          title,
          images: [
            {
              url: getOGImageURL({ regionCode, store }),
            },
          ],
        }}
      />
      <BreadcrumbJsonLd itemListElements={breadcrumbData} />
    </>
  );
};

PLPSeo.propTypes = {
  SiteProps: PropTypes.object.isRequired,
};
